import { Injectable, Inject } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

Injectable()
export class RequestInterceptor implements HttpInterceptor{

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
        let Request = req.clone();
        //Если есть активная сессия в локал сторэдж
        if (localStorage && localStorage.length > 0){
            //Добавляем токен и версию во все запросы
            const token = localStorage.getItem('yoola_app:token');
            const version = localStorage.getItem('yoola_app:version');

            // let _headers = {};
            // if (token) _headers['Authorization'] = `Bearer ${token}`;
            // if (version) _headers['X-App-Version'] = version;
            // const headers = new HttpHeaders(_headers);
            // Request = req.clone({headers});

            let headers: HttpHeaders = new HttpHeaders();
            headers = req.headers.append('Authorization', `Bearer ${token}`).append('X-App-Version', `${version}`);
            Request = req.clone({headers: headers});

            //Если в запросе есть запрос словарей, то закодируем его в массив в base64
            if (Request.params.has('d')){
                Request = Request.clone({params: Request.params.set('d', this.encodeB64(Request.params.get('d').split(',')))});
            }

            //Если в запросе есть запрос фильтров, то закодируем его в массив в base64
            if (Request.params.has('filters')){
                Request = Request.clone({params: Request.params.set('filters', this.encodeB64(Request.params.get('filters')))});
            }

            //Если в запросе есть строка поиска, то закодируем его в base64
            if (Request.params.has('search')){
                Request = Request.clone({params: Request.params.set('search', this.encodeB64(Request.params.get('search')))});
            }

            //Если в теле запроса есть строка поиска, то закодируем в base64
            if (Request.body && Request.body.search){
                Request.body.search = this.encodeB64(Request.body.search);
            }

            //Если в теле запроса есть фильтр (пользовательский), то закодируем в base64
            if (Request.body && Request.body.filter){
                Request.body.filter = this.encodeB64(Request.body.filter);
            }

            //Если в теле запроса есть фильтр (для выборки), то закодируем в base64 (только для CSV)
            if (Request.body && Request.body.filters){
                Request.body.filters = this.encodeB64(Request.body.filters);
            }
        }

        //Проверка версии приложения идет на всех роутах кроме login
        return next.handle(Request).catch((err) => {
            switch (err.status) {
                //Ошибка версии -> разлогин пользователя
                //Ошибка доступа -> разлогин пользователя
                case 401: case 403: {
                    // localStorage.clear(); 
                    ['version', 'scopes', 'token', 'iwd'].map(item => localStorage.removeItem(`yoola_app:${item}`));
                    window.location.href = '/login';
                    break;
                }
            }
            return Observable.throw(err);
        });
    }

    private encodeB64(obj){
        let stringToEncode: string;
        if (typeof obj === 'object'){
            stringToEncode = JSON.stringify(obj);
        } else if (typeof obj === 'string'){
            stringToEncode = obj;
        }
        if (stringToEncode.length > 0){
            return btoa(encodeURIComponent(stringToEncode).replace(
                /%([0-9A-F]{2})/g, (match, p1) => {
                    let code = `0x${p1}`;
                    return String.fromCharCode(+code);
                }
            ));
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/request-interceptor.service.ts